/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface SampleWriteUrls
 *
 */
// create custom validators for the regexes
export interface SampleWriteUrls {
    /**
     *
     * #type string
     * #memberof SampleWriteUrls
        
        
         */
    full: string;
    /**
     *
     * #type string
     * #memberof SampleWriteUrls
        
        
         */
    thumb: string;
}
/**
 * Check if a given object implements the SampleWriteUrls interface.
 */
export function instanceOfSampleWriteUrls(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "full" in value;
    isInstance = isInstance && "thumb" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const SampleWriteUrlsTypiaAssertEquals = (input: any) => {
    return ((input: any): SampleWriteUrls => {
        const __is = (input: any, _exceptionable: boolean = true): input is SampleWriteUrls => {
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.full && "string" === typeof input.thumb && (2 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["full", "thumb"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is SampleWriteUrls => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.full || $guard(_exceptionable, {
                    path: _path + ".full",
                    expected: "string",
                    value: input.full
                })) && ("string" === typeof input.thumb || $guard(_exceptionable, {
                    path: _path + ".thumb",
                    expected: "string",
                    value: input.thumb
                })) && (2 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["full", "thumb"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "SampleWriteUrls",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "SampleWriteUrls",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const SampleWriteUrlsTypiaAssertStringify = (input: SampleWriteUrls): string => {
    return ((input: any): string => { const assert = (input: any): SampleWriteUrls => {
        const __is = (input: any): input is SampleWriteUrls => {
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).full && "string" === typeof (input as any).thumb);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is SampleWriteUrls => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.full || $guard(_exceptionable, {
                    path: _path + ".full",
                    expected: "string",
                    value: input.full
                })) && ("string" === typeof input.thumb || $guard(_exceptionable, {
                    path: _path + ".thumb",
                    expected: "string",
                    value: input.thumb
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "SampleWriteUrls",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "SampleWriteUrls",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: SampleWriteUrls): string => {
        const $string = (typia.createAssertStringify as any).string;
        return `{"full":${$string((input as any).full)},"thumb":${$string((input as any).thumb)}}`;
    }; return stringify(assert(input)); })(input);
};
export const SampleWriteUrlsValidatorShape = {
    'full': yup.string().defined(),
    'thumb': yup.string().defined(),
};
export const SampleWriteUrlsValidator = yup.object().shape(SampleWriteUrlsValidatorShape);
export const SampleWriteUrlsStringifyShapeProperties: ObjectSchema['properties'] = {
    'full': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'thumb': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const SampleWriteUrlsStringifyShape: ObjectSchema = {
    title: 'SampleWriteUrls Stringifier',
    type: 'object',
    properties: {
        ...SampleWriteUrlsStringifyShapeProperties
    },
    required: [
        'full',
        'thumb',
    ],
};
export const SampleWriteUrlsStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SampleWriteUrlsStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const SampleWriteUrlsStringify: (data: SampleWriteUrls) => string = SampleWriteUrlsStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function SampleWriteUrlsFromJSON(json: any): SampleWriteUrls {
    return SampleWriteUrlsFromJSONTyped(json, false);
}
export function SampleWriteUrlsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SampleWriteUrls {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'full': json['full'],
        'thumb': json['thumb'],
    };
}
export function SampleWriteUrlsToJSON(value?: SampleWriteUrls | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'full': value.full,
        'thumb': value.thumb,
    };
}
